import ko from 'knockout';

export class ParticipantListViewModel {
    readonly uuid: string;
    readonly displayName: string;
    readonly isChair: boolean;
    readonly toggleMicrophoneCallback: (uuids: string[]) => void;
    readonly lowerHandCallback: (uuid: string) => void;

    public isMicrophoneMuted = ko.observable<boolean>(false);
    public isHandRaised = ko.observable<boolean>(false);
    public dirtyMuteStateCounter = 0; // If > 0 local mute state is not in sync with global VDX mute state

    constructor(
        uuid: string,
        displayName: string,
        isChair: boolean,
        isHandRaised: boolean,
        toggleMicrophoneCallback: (uuids: string[]) => void,
        lowerHandCallback: (uuid: string) => void,
    ) {
        this.uuid = uuid;
        this.displayName = displayName;
        this.isChair = isChair;
        this.isHandRaised(isHandRaised);
        this.toggleMicrophoneCallback = toggleMicrophoneCallback;
        this.lowerHandCallback = lowerHandCallback;
    }

    public toggleMicrophone(): void {
        this.isMicrophoneMuted(!this.isMicrophoneMuted());
        this.dirtyMuteStateCounter++;
        this.toggleMicrophoneCallback([this.uuid]);
    }

    public lowerHand(): void {
        this.isHandRaised(false);
        this.lowerHandCallback(this.uuid);
    }
}
